import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import "../css/LandingPage.css";
import Navbar from "../Components/NavBar";


const FAMILY_IMAGES = [
  {
    src: "/imgs/family_doorway.jpg",
  },
  {
    src: "/imgs/puppy.jpg",

  },
  {
    src: "/imgs/family_wall.jpg",

  },
  {
    src: "/imgs/boys_solo.jpg",

  },
  {
    src: "/imgs/group_hug.jpg",

  },
  {
    src: "/imgs/boys_solo2.jpg",

  },
 
];


export default function About() {
  return (
    <div className="landing-container">
      <Navbar variant="about" />

      {/* BIO */}
      <section className="about-section about-bio" id="bio">
        <div className="about-section-inner">
          <div className="about-grid">
            <div className="about-image">
              <img
                src="/imgs/brooke-headshot2.jpeg"
                alt="Brooke Roscoe - Northern Kentucky Real Estate"
              />
            </div>

            <div className="about-content">
              <h2
                style={{
                  fontFamily: "var(--font-script)",
                  fontSize: "clamp(2rem, 6vw, 3.5rem)",
                  lineHeight: 1.05,
                }}
              >
                Hello,{" "}
                <span
                  style={{
                    fontFamily: "var(--font-display)",
                    fontSize: "clamp(2rem, 6vw, 3.5rem)",
                    lineHeight: 1.05,
                  }}
                >
                  I am {""}
                </span>
                <span
                  style={{
                    fontFamily: "var(--font-display)",
                    color: "var(--brand-accent)",
                    fontSize: "clamp(2rem, 6vw, 3.5rem)",
                    lineHeight: 1.05,
                  }}
                >
                  Brooke Roscoe
                </span>
              </h2>
              <p>
                Thank you for taking the time to learn a little more about who I am.
                I was born and raised in Kentucky, and this has always been home.
                My roots run deep here, and I take pride in helping others feel confident
                in where they live.
              </p>

              <p>
                I earned my Bachelor of Arts in Public Relations from Eastern Kentucky University
                and began my career in interior design right out of college. Over the past
                22 years, I’ve built a strong background in the home industry, including
                working as a Senior Designer for one of the region’s largest home builders
                and later owning my interior design business, Beyond The Brick.
              </p>

              <p>
                These experiences naturally led me into real estate, where design plays
                a major role for both sellers and buyers. Sellers benefit from presenting
                their homes at their very best, while buyers gain a clear visual perspective
                when searching for style, opportunity, and potential.
              </p>

              <p>
                When I’m not wearing my REALTOR® hat, I’m proudly wearing my mom and wife hat.
                I’ve been married for 20 years, have two teenage boys, and a cockapoo named
                Macy. We’re an active family who enjoys the outdoors, community activities,
                traveling, sports, family gatherings, and time with friends — truly living
                life to the fullest.
              </p>


              <div className="about-socials">
                <a
                  href="https://www.facebook.com/brookeroscoerealtor"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Facebook"
                >
                  <FaFacebookF />
                </a>

                <a
                  href="https://www.instagram.com/brookeroscoerealtor/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Instagram"
                >
                  <FaInstagram />
                </a>

                <a
                  href="https://www.linkedin.com/in/brooke-roscoe/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="LinkedIn"
                >
                  <FaLinkedinIn />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAMILY GALLERY */}
      <section className="about-section about-gallery" id="gallery">
        <div className="about-section-inner about-gallery-inner">
           <h3
              style={{
                fontSize: "clamp(2rem, 6vw, 3.5rem)",
                fontFamily: "var(--font-display)",
                lineHeight: 1.05,
              }}
            >
              Meet{" "}
              <span
                style={{
                  fontFamily: "var(--font-script)",
                  color: "var(--brand-accent)",
                  fontSize: "clamp(2rem, 6vw, 3.5rem)",
                  lineHeight: 1.05,
                }}
              >
                My Family
              </span>
            </h3>

          <div className="about-gallery-grid">
            {FAMILY_IMAGES.map((img, i) => (
              <div className="about-gallery-card" key={i}>
                <div className="about-gallery-media">
                  <img
                    src={img.src}
                    alt={img.caption}
                    loading="lazy"
                  />
                </div>

                <div className="about-gallery-meta">
                  <div className="about-gallery-caption">{img.caption}</div>
                  <div className="about-gallery-note">{img.note}</div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* MEET MY SISTER */}
      <section className="about-section about-sister" id="sister">
        <div className="about-section-inner about-sister-inner">
          <div className="about-sister-grid">
            <div className="about-sister-content">
              <h3 style={{ fontFamily: "var(--font-display)", color: "var(--text-on-dark)", textAlign: "center", fontSize: "clamp(2rem, 6vw, 2.5rem)", lineHeight: 1.05 }}>
                Meet My Sister<br />
                <span style={{ fontFamily: "var(--font-script)" }}>Stacy Payne</span>
              </h3>

              <p>
                Stacy works as my Marketing Assistant and helps facilitate the
                behind-the-scenes details of every real estate transaction.
                She works directly alongside me to ensure each client experience
                is smooth, organized, and thoughtfully executed.
              </p>

              <p>
                You may also find Stacy serving as the Head Varsity Tennis Coach
                for a local high school. She stays busy raising two teenage girls
                with her husband, Jason, while balancing both career paths.
              </p>

              <p>
                In her free time, Stacy enjoys playing tennis, reading, and trips
                to Destin. We’re lucky to live just one mile apart and raise our
                families close together.
              </p>
            </div>

            <div className="about-sister-image">
              <img
                src="/imgs/sister_headshot2.jpeg"
                alt="Stacy Payne - Marketing Assistant"
              />
            </div>
          </div>
        </div>
      </section>

            {/* CREDENTIALS */}
      <section className="about-section about-credentials">
        <div className="about-section-inner">
          <div className="about-credentials-grid">

            <div className="about-credentials-column">
              <h3>Education</h3>
              <p>Bachelor of Arts, Public Relations</p>
              <p>Eastern Kentucky University</p>
              <p>Kentucky Real Estate License</p>
            </div>

            <div className="about-credentials-column">
              <h3>Professional Background</h3>
              <p>Senior Designer at Fischer Homes</p>
              <p>Owner/Designer at Beyond the Brick</p>
              <p>REALTOR® at Keller Williams Realty Services</p>
            </div>

            <div className="about-credentials-column">
              <h3>Professional Group Involvement</h3>
              <p>National Association of REALTORS®</p>
              <p>Northern Kentucky Association of REALTORS®</p>
              <p>NKAR Young Professionals</p>
              <p>Northern Kentucky Chamber Member</p>
              <p>Zillow Premier Agent</p>
            </div>

          </div>
        </div>
      </section>


    </div>
  );
}
